module.exports = __webpack_public_path__ + "static/media/welcome_sound.d2ad63ce.wav";